module.exports = __webpack_public_path__ + "img/3.23327754.jpg";